// @flow
import CleaningServiceReports from './CleaningServiceReportsLoader'
export default CleaningServiceReports
